export const enum OrganizationsEndpoints {
  USERS = '/users',
  AUTH = '/auth',
  ORGANIZATION = 'organization',
  ORGANIZATIONS = 'api/v1/organizations'
}
